<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { isCloudflareDeployment, refreshDeploymentSettings } from '@/services/deployment'
function refresh() {
  if (isCloudflareDeployment) void refreshDeploymentSettings().catch(() => undefined)
}
onMounted(() => { refresh(); window.addEventListener('focus', refresh) })
onUnmounted(() => window.removeEventListener('focus', refresh))
</script>

<template>
  <router-view />
</template>
